const body = document.querySelector('body');
if( body.classList.contains('single-press') ){

	let tertiaryMenus = document.querySelectorAll('.wp-block-navigation-item__content[href*="news"]');
	tertiaryMenus.forEach( item => {
		item.parentElement.classList.add('current-menu-item')
	} )
	let niceSelect = document.querySelectorAll('.nice-select .multiple-options .current');
	niceSelect.forEach( current => {
		current.innerHTML = tertiaryMenus[0].querySelector('.wp-block-navigation-item__label').innerHTML;
	})

	menuItems = document.querySelectorAll( '.menu-item a[href*="news"]');
	menuItems.forEach( menuItem => {
		menuItem.parentElement.classList.add('current-menu-item');
		menuItem.closest('.mega-menu-item.mega-menu-item-has-children.mega-menu-megamenu').classList.add('mega-current-menu-item');
	} )
}
